import { Api, CampaignAdditionalMaterialWithMilestones, CampaignSplitOrderGroupsResponse, GetCampaignAdditionalMaterialMilestonesParams, GetCampaignSplitOrderOrderGroupsParams, GetCampaignSplitOrderVisualsParams } from '~/api';
import { buildModule, createFiltersModule, defineArrayFilter, defineSingleFilter } from '../utils';
import $axios from '~/plugins/axios';
import { fetchAllPages } from '~/helpers/common';

export type CampaignSplitOrderVisualsGroup = CampaignSplitOrderGroupsResponse['payload'][number];
const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		baseFilters: createFiltersModule({
			filters: {
				tab: defineSingleFilter('tab', String, 'print'),
				delay: defineSingleFilter('delay', String, undefined),
				orderType: defineSingleFilter('orderType', String, 'format'),
			},
		}),
		filters: createFiltersModule({
			filters: {
				campaignSplitId: defineSingleFilter('campaignSplit', Number),
				campaignTypeId: defineSingleFilter('campaignType', Number),
				searchTerm: defineSingleFilter('searchTerm', String, undefined),
				monthIso: defineSingleFilter('month', String, undefined),
				additionalMaterialRequestId: defineSingleFilter('additionalMaterialRequest', Number),
				customFilterIds: defineArrayFilter('customFilterIds', Number),
				customFilterValues: defineArrayFilter('customFilterValues', String),
			},
		}),
	})
	.withState({
		orders: [] as CampaignSplitOrderVisualsGroup[],
		additionalMaterialOrders: [] as CampaignAdditionalMaterialWithMilestones[],
	})
	.withGetters({
		orders: state => state.orders,
		additionalMaterialOrders: state => state.additionalMaterialOrders,
	})
	.withMutations({
		SET_ORDERS (state, value: CampaignSplitOrderVisualsGroup[]) {
			state.orders = [
				...value,
			];
		},
		SET_ADDITIONAL_MATERIAL_ORDERS (state, value: CampaignAdditionalMaterialWithMilestones[]) {
			state.additionalMaterialOrders = [
				...value,
			];
		},
		RESET_ORDERS (state) {
			state.orders = [];
		},
	})
	.withActions({
		async getSplitVisualOrders ({ commit }, params: GetCampaignSplitOrderVisualsParams) {
			commit('RESET_ORDERS');
			const { data } = await api.get('/campaign-split-order/visuals', { params });
			commit('SET_ORDERS', data.payload);
		},
		async getSplitOrderGroups ({ commit }, params: GetCampaignSplitOrderOrderGroupsParams) {
			commit('RESET_ORDERS');
			const { data } = await api.get('/campaign-split-order/order-groups', { params });
			commit('SET_ORDERS', data.payload);
		},
		async getAdditionalMaterialOrders ({ commit }, params: GetCampaignAdditionalMaterialMilestonesParams = {}) {
			const orders = await fetchAllPages('/campaign-additional-material/milestones', params)<CampaignAdditionalMaterialWithMilestones>(api);
			commit('SET_ADDITIONAL_MATERIAL_ORDERS', orders);
		},
	});
